import Navbar from "./navbar";
import Footer from "./footer";
import {useContext, useEffect} from "react";
import axios from "../axios/axios";
import {Endpoints} from "../axios/endpoints";
import {AuthContext} from "../contexts/auth";
import {toast} from "react-toastify";
import {useHistory} from "react-router";

function Layout({children}) {

    let history = useHistory()
    const [state, dispatch] = useContext(AuthContext)

    useEffect(() => {
        if (!state.auth) {
            return
        }

        axios({
            method: "get",
            url: Endpoints.USER(),
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("token")
            }
        }).then(res => {
            dispatch({
                type: "change_username",
                payload: {
                    username: res.data.username
                }
            })
            dispatch({
                type: "change_preferences",
                payload: {
                    preferences: res.data.preferences
                }
            })
        }).catch(err => {
            if (err.response && err.response.status) {
                switch (err.response.status) {
                    case 401:
                        toast.error("Du musst dich erneut einloggen")
                        history.push("/logout")
                        break;
                    default:
                        toast.error("Da ist was schiefgelaufen. Bitte versuche es später noch einmal.")
                        break;
                }
            }
        })
    }, [])

    return (
        <>
            <Navbar/>
            <div className="container" style={{minHeight: "80vh"}}>
                {children}
            </div>
            <Footer/>
        </>
    )
}

export default Layout